<template>
    <transition :name="transitionName">
        <Toast
            v-if="visible"
            :title="title"
            :description="description"
            :placement="placement"
            :variant="variant"
            @close="hide"
        />
    </transition>
</template>

<script>
import { evtBus } from '@/main';
import Toast from './index.vue';

const DEFAULT_HIDE_DELAY = 4000;

export default {
    name: 'ToastHandler',
    components: {
        Toast,
    },
    props: {
        placement: {
            type: String,
            default: 'bottom-center',
        },
    },
    data() {
        return {
            visible: false,
            title: '',
            description: '',
            variant: 'default',
            hideTimer: null,
        }
    },
    computed: {
        transitionName() {
            return this.placement.startsWith('top') ? 'toast-top' : 'toast-bottom';
        },
    },
    methods: {
        onShow(payload) {
            const { title = '', description = '', hideDelay = DEFAULT_HIDE_DELAY, variant = 'default' } = payload || {};

            this.title = title;
            this.description = description;
            this.variant = variant;
            this.visible = true;
            this.scheduleHide(hideDelay);
        },
        hide() {
            this.clearTimer();
            this.visible = false;
        },
        scheduleHide(hideDelay) {
            this.clearTimer();
            if (hideDelay > 0) {
                this.hideTimer = setTimeout(this.hide, hideDelay);
            }
        },
        clearTimer() {
            if (this.hideTimer) {
                clearTimeout(this.hideTimer);
                this.hideTimer = null;
            }
        },
    },
    created() {
        evtBus.$on('evt_toast_show', this.onShow);
    },
    beforeDestroy() {
        evtBus.$off('evt_toast_show', this.onShow);
        this.clearTimer();
    },
}
</script>

<style scoped>
.toast-bottom-enter-active,
.toast-bottom-leave-active,
.toast-top-enter-active,
.toast-top-leave-active {
    transition: opacity 0.2s ease, transform 0.2s ease;
}

.toast-bottom-enter,
.toast-bottom-leave-to {
    opacity: 0;
    transform: translateY(8px);
}

.toast-top-enter,
.toast-top-leave-to {
    opacity: 0;
    transform: translateY(-8px);
}
</style>
